import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <footer>
          <p>
            Coded and created by{" "}
            <a
              href="https://www.linkedin.com/in/mariana-tellez-resendiz/"
              title="Mariana's LinkedIn"
            >
              Mariana Tellez Resendiz
            </a>
          </p>
      </footer>
    </div>
  );
}
